export default (sentence, replacements) => sentence.replace(/{\w+}/g, (placeholder) => replacements[placeholder.substring(1, placeholder.length - 1)] || placeholder);
